<template>
  <el-row class="container">
    <el-col :span="24" class="header">
      <el-col :span="10" class="logo" :class="collapsed?'logo-collapse-width':'logo-width'">
        <span @click='hones' style="cursor: pointer;">荐康客系统管理</span>
      </el-col>
      <!-- <el-col :span="10">
				<div class="tools" @click.prevent="collapse">
					<i class="el-icon-s-fold"></i>
				</div>
			</el-col> -->
      <el-col :span="4" class="userinfo">
        <el-dropdown trigger="hover">
          <span class="el-dropdown-link userinfo-inner">{{$store.state.userInfo.fullName}}</span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item @click.native="logout">退出登录</el-dropdown-item>
            <el-dropdown-item @click.native="upPwd">修改登录密码</el-dropdown-item>
            <el-dropdown-item @click.native="dialogVisibleFh = true">修改分红密码</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </el-col>
    </el-col>
    <el-col :span="24" class="main">
      <aside :class="collapsed?'menu-collapsed':'menu-expanded'">
        <!--导航菜单-->
        <el-menu :default-active="$route.path" class="el-menu-vertical-demo widthmenu" @open="handleopen" @close="handleclose" @select="handleselect" unique-opened router v-show="!collapsed">
          <template v-for="(item,index) in $store.state.userInfo.menu">
            <el-submenu :index="index+''" v-if="item.child" :key="index">
              <template slot="title">
								{{item.menuName}}
								<span class="msgCount" v-if="item.msg">{{item.msg}}</span>
							</template>
              <el-menu-item v-for="child in item.child" :index="child.path" :key="child.path">{{child.menuName}}</el-menu-item>
            </el-submenu>
            <el-menu-item v-else :index="item.path" :key="index">{{item.menuName}}</el-menu-item>
          </template>
        </el-menu>
        <!--导航菜单-折叠后-->
        <!-- <ul class="el-menu el-menu-vertical-demo collapsed" v-show="collapsed" ref="menuCollapsed">
					<li v-for="(item,index) in $router.options.routes" v-if="!item.hidden" class="el-submenu item">
						<template v-if="!item.leaf">
							<div class="el-submenu__title" style="padding-left: 20px;" @mouseover="showMenu(index,true)" @mouseout="showMenu(index,false)"><i :class="item.iconCls"></i></div>
							<ul class="el-menu submenu" :class="'submenu-hook-'+index" @mouseover="showMenu(index,true)" @mouseout="showMenu(index,false)"> 
								<li v-for="child in item.children" v-if="!child.hidden" :key="child.path" class="el-menu-item" style="padding-left: 40px;" :class="$route.path==child.path?'is-active':''" @click="$router.push(child.path)">{{child.name}}</li>
							</ul>
						</template>
						<template v-else>
							<li class="el-submenu">
								<div class="el-submenu__title el-menu-item" style="padding-left: 20px;height: 56px;line-height: 56px;padding: 0 20px;" :class="$route.path==item.children[0].path?'is-active':''" @click="$router.push(item.children[0].path)"><i :class="item.iconCls"></i></div>
							</li>
						</template>
					</li>
				</ul> -->
      </aside>
      <section class="content-container">
        <div class="grid-content bg-purple-light">
          <el-col :span="24" class="breadcrumb-container">
            <strong class="title">{{$route.name}}</strong>
            <el-breadcrumb separator="/" class="breadcrumb-inner">
              <el-breadcrumb-item v-for="item in $route.matched" :key="item.path">
                {{ item.name}}
              </el-breadcrumb-item>
            </el-breadcrumb>
          </el-col>
          <el-col :span="24" class="content-wrapper">
            <transition name="fade" mode="out-in">
              <router-view></router-view>
            </transition>
          </el-col>
        </div>
      </section>
    </el-col>

    <el-dialog title="修改登录密码" :visible.sync="dialogVisible" :modal-append-to-body='false' width="400px">
      <el-form :model="form">
        <el-form-item label="旧密码" label-width='60px'>
          <el-input type="password" maxlength="18" v-model="form.oldPassword" autocomplete="off" placeholder="请输入旧密码"></el-input>
        </el-form-item>
        <el-form-item label="新密码" label-width='60px'>
          <el-input type="password" maxlength="18" v-model="form.newPassword" autocomplete="off" placeholder="请输入新密码"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="subUpPwd">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog title="修改分红密码" :visible.sync="dialogVisibleFh" :modal-append-to-body='false' width="400px">
      <el-form :model="form2">
        <el-form-item label="旧密码" label-width='60px'>
          <el-input type="password" maxlength="18" v-model="form2.oldPassword" autocomplete="off" placeholder="请输入旧密码"></el-input>
        </el-form-item>
        <el-form-item label="新密码" label-width='60px'>
          <el-input type="password" maxlength="18" v-model="form2.newPassword" autocomplete="off" placeholder="请输入新密码"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisibleFh = false">取 消</el-button>
        <el-button type="primary" @click="subUpFhPwd">确 定</el-button>
      </div>
    </el-dialog>

  </el-row>
</template>

<script>
export default {
  data() {
    return {
      collapsed: false,
      dialogVisible: false,
      dialogVisibleFh: false,
      form: {
        oldPassword: '',
        newPassword: '',
      },
      form2: {
        oldPassword: '',
        newPassword: '',
      },
    }
  },
  created() {
    setInterval(() => {
      this.getMsg()
    }, 4000)
  },
  methods: {
    getMsg() {
      this.httpGet('/admin/home/backlog', {}, true, true).then((res) => {
        if (res.code == 200) {
            console.log(this.$store.state.userInfo)
            // this.$store.state.userInfo.menu[5].msg = res.data.ddglCount
            // this.$store.state.userInfo.menu[9].msg = res.data.khglCount
            // this.$store.state.userInfo.menu[3].msg = res.data.sjglCount
            this.$store.state.userInfo.menu[10].msg = res.data.styzbCount
            // this.$store.state.userInfo.menu[7].msg = res.data.txglCount
            // this.$store.state.userInfo.menu[1].msg = res.data.yjglCount
            // this.$store.state.userInfo.menu[10].msg = res.data.yysglCount
            this.$store.state.userInfo.menu[9].msg = res.data.yysglCount
            this.$store.state.userInfo.menu[3].msg = res.data.ddglCount
            this.$store.state.userInfo.menu[8].msg = res.data.khglCount
            this.$store.state.userInfo.menu[2].msg = res.data.sjglCount
            this.$store.state.userInfo.menu[6].msg = res.data.txglCount
            this.$store.state.userInfo.menu[0].msg = res.data.yjglCount
          console.log( this.$store.state.userInfo.menu)
          this.$forceUpdate()
        }
      })
    },
    hones() {
      this.$router.push('/home')
    },
    onSubmit() {
      console.log('submit!')
    },
    handleopen() {
      //console.log('handleopen');
    },
    handleclose() {
      //console.log('handleclose');
    },
    handleselect: function (a, b) {},
    //退出登录
    logout: function () {
      var _this = this
      this.$confirm('确认退出吗?', '提示', {
        //type: 'warning'
      })
        .then(() => {
          // sessionStorage.removeItem('user');
          this.logout()
        })
        .catch(() => {})
    },

    //退出
    logout() {
      this.httpPost('/logout').then((res) => {
        // console.log(res)
        if (res.code == 200) {
          this.$router.push('/')
        }
      })
    },
    //修改密码
    upPwd() {
      this.dialogVisible = true
    },
    //确定修改密码
    subUpPwd() {
      if (this.form.oldPassword.length < 6) {
        this.$message('请输入正确的旧密码')
        return false
      }
      if (this.form.newPassword.length < 6) {
        this.$message('请输入正确的新密码')
        return false
      }
      if (this.form.newPassword.length == this.form.oldPassword) {
        this.$message('新密码不能和旧密码一致')
        return false
      }
      this.dialogVisible = false
      this.httpPut('/updatePassword', this.$qs.stringify(this.form)).then(
        (res) => {
          if (res.code == 200) {
            this.$message.success('修改成功，请重新登录')

            setTimeout(() => {
              this.$router.push('/')
            }, 1000)
          }
        }
      )
    },
    subUpFhPwd() {
      if (this.form2.oldPassword.length < 6) {
        this.$message('请输入正确的旧密码')
        return false
      }
      if (this.form2.newPassword.length < 6) {
        this.$message('请输入正确的新密码')
        return false
      }
      if (this.form2.newPassword.length == this.form2.oldPassword) {
        this.$message('新密码不能和旧密码一致')
        return false
      }
      this.dialogVisibleFh = false
      this.httpPost(
        '/system/user/updateShareBonusPassword?oldPassword=' +
          this.form2.oldPassword +
          '&newPassword=' +
          this.form2.newPassword
      ).then((res) => {
        if (res.code == 200) {
          this.$message.success('修改成功')
        }
      })
    },
    //折叠导航栏
    collapse: function () {
      this.collapsed = !this.collapsed
    },
    showMenu(i, status) {
      this.$refs.menuCollapsed.getElementsByClassName(
        'submenu-hook-' + i
      )[0].style.display = status ? 'block' : 'none'
    },
  },
}
</script>

<style scoped lang="scss">
// @import '~scss_vars';
.widthmenu {
  width: 100% !important;
  overflow-y: auto;
  // background: #F0F2F5;
}
.widthmenu::-webkit-scrollbar {
  width: 0 !important;
}

.container {
  position: absolute;
  top: 0px;
  bottom: 0px;
  width: 100%;

  .header {
    height: 60px;
    line-height: 60px;
    background: #20a0ff;
    color: #fff;

    .userinfo {
      text-align: right;
      padding-right: 35px;
      float: right;

      .userinfo-inner {
        cursor: pointer;
        color: #fff;

        img {
          width: 40px;
          height: 40px;
          border-radius: 20px;
          margin: 10px 0px 10px 10px;
          float: right;
        }
      }
    }

    .logo {
      //width:230px;
      height: 60px;
      font-size: 22px;
      padding-left: 20px;
      padding-right: 20px;
      border-color: rgba(238, 241, 146, 0.3);
      border-right-width: 1px;
      border-right-style: solid;

      img {
        width: 40px;
        float: left;
        margin: 10px 10px 10px 18px;
      }

      .txt {
        color: #fff;
      }
    }

    .logo-width {
      width: 230px;
    }

    .logo-collapse-width {
      width: 60px;
    }

    .tools {
      padding: 0px 23px;
      width: 14px;
      height: 60px;
      line-height: 60px;
      cursor: pointer;
    }
  }

  .main {
    display: flex;
    // background: #324057;
    position: absolute;
    top: 60px;
    bottom: 0px;
    overflow: hidden;

    aside {
      flex: 0 0 230px;
      width: 230px;

      // position: absolute;
      // top: 0px;
      // bottom: 0px;
      .el-menu {
        height: 100%;
      }

      .collapsed {
        width: 60px;

        .item {
          position: relative;
        }

        .submenu {
          position: absolute;
          top: 0px;
          left: 60px;
          z-index: 99999;
          height: auto;
          display: none;
        }
      }
    }

    .menu-collapsed {
      flex: 0 0 60px;
      width: 60px;
    }

    .menu-expanded {
      flex: 0 0 230px;
      width: 230px;
    }

    .content-container {
      // background: #f1f2f7;
      flex: 1;
      // position: absolute;
      // right: 0px;
      // top: 0px;
      // bottom: 0px;
      // left: 230px;
      box-sizing: border-box;
      overflow: hidden;
      background: #f0f2f5;
      // padding: 10px;
      // padding-top: 0px;
      .breadcrumb-container {
        background: #ffffff;
        display: flex;
        align-items: center;
        height: 50px;
        justify-content: space-between;
        box-sizing: border-box;
        padding: 0 20px;
        //margin-bottom: 15px;
        .title {
          width: 200px;
          float: left;
          color: #475669;
        }

        .breadcrumb-inner {
          float: right;
        }
      }

      .content-wrapper {
        background-color: #fff;
        box-sizing: border-box;
        padding: 0 20px;
        height: calc(100vh - 110px);
        // background: #000000;
        overflow-y: auto;
      }
    }
  }
}


.msgCount{
	position: absolute;
	right: 40px;
	top: 20px;
	width: 20px;
	height: 20px;
	background: red;
	color: #fff;
	line-height: 20px;
	text-align: center;
	border-radius: 20px;
}
</style>
